import Main from "./Pages/Home";
import "./index.css";


function App() {
  return (
    <>
      <Main></Main>
      
    </>
  );
}

export default App;
